import React, { Fragment } from 'react'
import Collapse from '@material-ui/core/Collapse'
import BkFlowRoomCardNightlyRates from '../../../../room/elements/BkFlowRoomCardNightlyRates'

import _ from 'lodash'
import yn from 'yn'
import formatPrice from '../../../../../utilities/currency/formatPrice'

const BkFlowSidebarRoomCardDefault = (props) => {
	const {
		activeCurrencyData,
		arrival,
		adults,
		children,
		configData,
		currencyCode,
		currencySymbol,
		departure,
		destinationFeeAmount,
		detailsExpanded,
		displayedPriceFrequency,
		enhancementsData,
		handleDetailsAccordion,
		hotelLabels,
		nights,
		nightlyRateData,
		propertyClassType,
		renderAdult,
		renderChildren,
		roomName,
		roomPrice,
		roomRateCode,
		roomRatePlan,
	} = props

	return (
		<div className="bk-flow-payment__sidebar-room-card">
			{roomName && <h4>{ roomName }</h4>}
			<div className="bk-flow-payment__sidebar-room-card-rate-data">
				<span className="bk-flow-payment__sidebar-room-card-price">{ currencySymbol && currencySymbol }{ roomPrice }&nbsp;</span>
				<span className="bk-flow-payment__sidebar-room-card-currency">
					{ currencyCode && currencyCode }
					{ yn(process.env.REACT_APP_COMPONENT_PRICE_AVG_LABELS) && hotelLabels.avg ? ' ' + hotelLabels.avg : ' Avg'}
				</span>
				<span className="bk-flow-payment__sidebar-room-card-nights">/{ displayedPriceFrequency === 'per stay' ? hotelLabels.total : hotelLabels.night }</span>

				{ yn(process.env.REACT_APP_COMPONENT_ENABLE_GENERIC_LABELS) &&
					roomRateCode &&
					roomRateCode.includes(configData.hotel.options.payNow) ?
						<Fragment>
							<span className="bk-flow-payment__sidebar-room-card-divide"> | </span>
							<span className="bk-flow-payment__sidebar-room-card__rate-discount u-font-bold">{ hotelLabels.payNow ? hotelLabels.payNow : 'Pay Now'}</span>
						</Fragment>
				: yn(process.env.REACT_APP_COMPONENT_ENABLE_GENERIC_LABELS) &&
					roomRateCode &&
					roomRateCode.includes(configData.hotel.options.payLater) ?
						<Fragment>
							<span className="bk-flow-payment__sidebar-room-card-divide"> | </span>
							<span className="bk-flow-payment__sidebar-room-card__rate-discount u-font-bold">{ hotelLabels.payLater ? hotelLabels.payLater : 'Pay Later' }</span>
						</Fragment>
				:
					null
				}

				{ roomRatePlan &&
					<p className="bk-flow-payment__sidebar-room-card__rate-discount">
						{ destinationFeeAmount &&
							<span className="bk-flow-payment__sidebar-room-card__rate-destination-fee">
								{ hotelLabels.plus ? hotelLabels.plus : 'Plus' }&nbsp;
								<span className="u-font-bold">{ currencySymbol }{ formatPrice(destinationFeeAmount, 0) } { currencyCode }</span>&nbsp;
								{ propertyClassType === 30 ?
									hotelLabels.resortFee ? hotelLabels.resortFee : 'Resort Fee'
								: propertyClassType === 47 ?
									hotelLabels.amenityFee ? hotelLabels.amenityFee : 'Amenity Fee'
								:
									hotelLabels.destinationFee ? hotelLabels.destinationFee : 'Destination Fee'
								}
								&nbsp;/&nbsp;{ hotelLabels.night ? hotelLabels.night : 'Night' }
								<span className="bk-flow-payment__sidebar-room-card-divide"> | </span>
							</span>
						}
						{ roomRatePlan }
					</p>
				}
			</div>

			<div
				className="bk-flow-payment__sidebar-room-card-details-btn row middle-xs"
				onClick={() => handleDetailsAccordion()}
				tabIndex={0}
			>
				{ hotelLabels.viewDetails ? hotelLabels.viewDetails : 'View Details' }
				<i className="material-icons">{ detailsExpanded ? 'arrow_drop_up' : 'arrow_drop_down' }</i>
			</div>

			<Collapse
				in={ detailsExpanded }
				timeout={ 300 }
			>
				<div className="bk-flow-payment__sidebar-room-card-details">
					<p className="bk-flow-payment__sidebar-room-card-detail u-font-medium">
						<span className="u-font-bold">{ hotelLabels.arrive ? hotelLabels.arrive : 'Arrive' }</span>: { arrival }
					</p>
					<p className="bk-flow-payment__sidebar-room-card-detail u-font-medium">
						<span className="u-font-bold">{ hotelLabels.depart ? hotelLabels.depart : 'Depart' }</span>: { departure }
					</p>
					<p className="bk-flow-payment__sidebar-room-card-detail u-font-medium">
						<span className="u-font-bold">{ hotelLabels.nights ? hotelLabels.nights : 'Nights' }</span>: { nights }
					</p>
					<p className="bk-flow-payment__sidebar-room-card-detail u-font-medium">
						<span className="u-font-bold">{ hotelLabels.guests ? hotelLabels.guests : 'Guests' }: </span>
						{ adults > 0 ? renderAdult : null }
						{ children > 0 ? ', ' + renderChildren : null }
					</p>

					{ !_.isEmpty(nightlyRateData) &&
						<BkFlowRoomCardNightlyRates
							configData={configData}
							activeCurrencyData={activeCurrencyData}
							roomRateData={nightlyRateData}
							rateCurrencyCode={currencyCode}
							rateCurrencySymbol={currencySymbol}
						/>
					}

					{ !_.isEmpty(enhancementsData) &&
						<Fragment>
							<p className="bk-flow-payment__sidebar-room-card-detail u-font-medium">
								<span className="u-font-bold">
									{ hotelLabels.enhancements ? hotelLabels.enhancements : 'Enhancements' }:
								</span>
							</p>
							{ enhancementsData }
							<p className="bk-flow-payment__sidebar-room-card-services-disclaimer u-font-small">
								{ hotelLabels.additionalChargesMessage ?
									hotelLabels.additionalChargesMessage
								:
									'Each upgrade is special. A reservations specialist will reach out to customize your Betsy experience. You will not be charged for upgrades prior to arrival.'
								}
							</p>
						</Fragment>
					}
				</div>
			</Collapse>
		</div>
	)
}

export default BkFlowSidebarRoomCardDefault


// WEBPACK FOOTER //
// ./src/components/payment/sidebar/room/layouts/BkFlowSidebarRoomCardDefault.js